var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.widthLimitter)},[_c('div',{style:(_vm.styles.renderingAreaProvider)},[_c('iframe',{style:(_vm.styles.iframe),attrs:{"src":_vm.src,"frameborder":"0","allowfullscreen":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }